import SharedDocuments from './SharedDocuments';

export default SharedDocuments;
